import React, { ReactNode, useEffect } from 'react';
import * as userSlice from '../data/user.slice';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { useAppSelector } from '../hooks/useAppSelector';
import authService from '../services/authService';
import { webSocketService } from '../services/webSocketService';

export const WebSocketProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const loadedLoggedInUser = useAppSelector(
    userSlice.selectLoadedLoggedInUserInfo,
  );
  const loggedInUserNoAccess = useAppSelector(
    userSlice.selectLoggedInUserNoAccess,
  );
  const userInfo = useAppSelector(userSlice.selectLoggedInUserInfo);

  const shouldConnect =
    authService.isLoggedIn() && loadedLoggedInUser && !loggedInUserNoAccess;

  useEffect(() => {
    if (!shouldConnect) {
      webSocketService.disconnect();
      return;
    }

    webSocketService.connect(dispatch);

    return () => {
      webSocketService.disconnect();
    };
  }, [dispatch, shouldConnect]);

  useEffect(() => {
    if (!shouldConnect) {
      webSocketService.setSessionInfo({
        userAccountID: null,
        accessToken: null,
        accessTokenID: null,
      });
      return;
    }

    authService.getTokens().subscribe((tokens) => {
      webSocketService.setSessionInfo({
        accessToken: tokens.accessToken ?? null,
        accessTokenID: tokens.idToken ?? null,
      });
    });
  }, [shouldConnect]);

  useEffect(() => {
    if (!shouldConnect) {
      return;
    }

    webSocketService.setSessionInfo({
      userAccountID: userInfo?.userAccountID ?? null,
    });
  }, [shouldConnect, userInfo?.userAccountID]);

  return <>{children}</>;
};
